export const COMPONENT_PARAMS = {
    SHOW_DIVIDER: 'showDivider',
    SHOW_BOTTOM_DIVIDER: 'showBottomDivider',
    IS_CTA_BUTTON: 'isCtaButton',
};

export function getParamValue(param) {
    return param === '1';
}
